<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-01-11 18:24:08
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-01-12 14:52:49
 * @FilePath: /chaoyongtuan/src/views/shopManage/components/extensionDrawer/tableCell/timerPicker.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="flex flex-align-center">
		<el-date-picker :disabled="!row.enable" :picker-options="pickerOptions" v-model="row.delay_date"  value-format="yyyy-MM-dd" type="date" placeholder="选择日期"> </el-date-picker>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin.js';

export default {
	mixins: [mixin],
	components: {},
	data() {
		return {
            delay_date: '',
            pickerOptions: {
				disabledDate(time) {
					return time.getTime() < Date.now() - 8.64e7;
				},
			},
        };
	},
    watch:{
        'row.endTimer'(newVal){
            this.row.delay_date = newVal;
        }
    },
    methods:{
        
    }
};
</script>
